class popupForm {
  constructor() {
    const submitBtn = document.querySelector('.popup-form-action--submit');
    const consentCheckbox = document.getElementById('popupConsent');

    if (submitBtn && consentCheckbox) {
      submitBtn.classList.toggle('is-disabled', !consentCheckbox.checked);
      consentCheckbox.addEventListener('change', () => {
        submitBtn.classList.toggle('is-disabled', !consentCheckbox.checked);
      });
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        this.loadingSpinner();
        this.submittedForm();
      });
    }
  }

  loadingSpinner() {
    document.querySelector('.popup--button-container').classList.add('active');
  }

  submittedForm() {
    const emailInput = document.getElementById('popupEmail').value;

    // Check if email is valid before proceeding
    if (!this.validateEmail(emailInput)) {
      document.querySelector('.popup--validation').classList.remove('is-hidden');
      document.querySelector('.popup--button-container').classList.remove('active');
      return;
    } else {
      // Hide validation error if previously shown
      document.querySelector('.popup--validation').classList.add('is-hidden');
    }

    const options = {
      method: 'POST',
      headers: {
        revision: '2023-02-22',
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            list_id: 'Xm493Z',
            custom_source: 'First Time Buyer List',
            email: emailInput,
            properties: { newKey: '' }
          }
        }
      })
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=XYTG6S', options)
      .then(response => {
        if (response.status === 202) {
          setTimeout(() => {
            document.querySelector('.popup--success').classList.remove('is-hidden');
            document.querySelector('.popup-form--content').classList.add('success');

            // After another 2 seconds, hide the popup and set the cookie
            setTimeout(() => {
              addVerificationCookie(verificationCookieName, "true", calculateCookieDuration);
              verificationPopupElement.classList.add('disabled');
              document.body.classList.remove('verifier');
              document.body.classList.remove('no-scroll');
            }, 4000);
          }, 800);
        } else {
          setTimeout(() => {
            document.querySelector('.popup--error').classList.remove('is-hidden');
            document.querySelector('.popup--button-container').classList.remove('active');
          }, 500);
        }
      })
      .catch(err => {
        console.error('Error submitting form:', err);
      });
  }

  validateEmail(email) {
    // Basic email regex validation
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
}

new popupForm();